import React from "react";
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useBody } from "./state/BodyContext";
import { useAuth } from "../Auth/State/AuthContext";
import PersonalInfo from "./PersonalInfo";
import localStorageManagement from "../Security/LocalStorageManagement";
import AliasItem from "./Menu/AliasItem";
import AreasItem from "./Menu/AreasItem";
import HomeItem from "./Menu/HomeItem";
import TraduccionesItem from "./Menu/TraduccionesItem";
import DifusionesItem from "./Menu/DifusionesItem";
import KeyCloak from "../Auth/Keycloak";
import {
    ACCESO_DIFUSIONES,
    ACCESO_ALIAS,
    ACCESO_RECIBOS,
    ACCESO_AREAS,
    ACCESO_BUSCADOR_INTERNOS,
    ACCESO_AGENDA,
    ACCESO_VER_ROLES,
    ACCESO_ALTA_USUARIOS,
    ACCESO_USUARIOS,
    ACCESO_VPN,
    ACCESO_CREDENCIAL,
    ACCESO_SUELDOS
} from "../Contantes/Constantes";
import NoticeItem from "./Menu/NoticeItem";
import TicketeraItem from "../Ticketera/Menu/TicketeraItem";
import ReciboItem from "./Menu/ReciboItem";
import CredencialItem from "./Menu/CredencialItem";
import WifiItem from "./Menu/WifiItem";
import VPNItem from "./Menu/VPNItem";
import Drawer from '@mui/material/Drawer';
import ArchivosItem from "./Menu/ArchivosItem";
import BuscadorInternosItem from "./Menu/BuscadorInternosItem";
import SueldosItem from "./Menu/SueldosItem";
const drawerWidth = 250;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: 'calc(56px + 1px)',
    [theme.breakpoints.up('sm')]: {
        width: 'calc(64px + 1px)',
    },
});

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0px 8px',
    ...theme.mixins.toolbar,
}));

const DrawerStyled = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),
        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),
    }),
);

export default function Menu({ openMenu, toggleDrawer }) {
    const theme = useTheme();
    const { openM, setOpenM } = useBody();
    const { user, hasRole, isLogedIn, esFiliacion, masDeUnaFiliacion } = useAuth();
    const matches = useMediaQuery('(min-width:600px)');

    function changeVisibilityMenu() {
        setOpenM(!openM);
    }

    const addMenuItemView = (menuItem) => {
        localStorageManagement.addMenuItemView(menuItem);
        if (openM) {
            setOpenM(false);
        }
        if (openMenu) {
            toggleDrawer();
        }
    }

    const orderMenu = () => {
        if (!KeyCloak.isLoggedIn() && isLogedIn()) return;
        const modulosInfo = localStorageManagement.getModulosInfo();
        return modulosInfo.sort((a, b) => a[1] - b[1]).reverse();
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <DrawerStyled
                variant={matches ? "permanent" : null}
                open={matches ? openM : openMenu}
            >
                <DrawerHeader>
                </DrawerHeader>
                <Divider />
                <PersonalInfo
                    triggerChangeVisibilityMenu={changeVisibilityMenu}
                    visibilityMenu={matches ? openM : openMenu}
                />
                <List>
                    <Divider />
                    <HomeItem onClick={() => addMenuItemView("home")} />
                    {orderMenu().map((modulo, index) => {
                        switch (modulo[0]) {
                            case "buscador_interno":
                                return isLogedIn ? (
                                    <BuscadorInternosItem
                                        key={index}
                                        onClick={() => {
                                            addMenuItemView("buscador_iterno");
                                        }}
                                    />
                                ) : null;
                            /* case "wifi":
                                return <WifiItem openMenu={openM} addMenuItemView={addMenuItemView} />; */
                            case "alias":
                                return hasRole(ACCESO_ALIAS) ? (
                                    <AliasItem key={index} onClick={() => addMenuItemView("alias")} />
                                ) : null;
                            case "difusiones":
                                return hasRole(ACCESO_DIFUSIONES) ? (
                                    <DifusionesItem key={index} onClick={() => addMenuItemView("difusiones")} />
                                ) : null;
                            case "areas":
                                return hasRole(ACCESO_USUARIOS) ||
                                    hasRole(ACCESO_ALTA_USUARIOS) ||
                                    hasRole(ACCESO_AREAS) ||
                                    hasRole(ACCESO_AGENDA) ||
                                    hasRole(ACCESO_VER_ROLES) ? (
                                    <AreasItem key={index} openMenu={openM} addMenuItemView={addMenuItemView} />
                                ) : null;
                            case "noticias":
                                return <NoticeItem key={index} onClick={() => addMenuItemView("noticias")} />;
                            case "vpn":
                                return hasRole(ACCESO_VPN) ? (
                                    <VPNItem key={index} onClick={() => addMenuItemView("vpn")} />
                                ) : null;
                            case "recibos":
                                return hasRole(ACCESO_RECIBOS) && user.legajoPersonaUTN && user.legajoPersonaUTN !== '-' ? (
                                    <ReciboItem key={index} onClick={() => addMenuItemView("recibos")} />
                                ) : null;
                            case "traducciones":
                                return isLogedIn ? (
                                    <TraduccionesItem key={index} openMenu={openM} addMenuItemView={addMenuItemView} />
                                ) : null;
                            case "ticketera":
                                return esFiliacion("Alumno") && !masDeUnaFiliacion() ? null : (
                                    <TicketeraItem key={index} onClick={() => addMenuItemView("ticketera")} />
                                );
                            case "credencial":
                                return hasRole(ACCESO_CREDENCIAL) ? (
                                    <CredencialItem key={index} onClick={() => addMenuItemView("credencial")} />
                                ) : null;
                            case "archivos":
                                return <ArchivosItem key={index} onClick={() => addMenuItemView("archivos")} />;
                            case "sueldos":
                                return hasRole(ACCESO_SUELDOS) ? (
                                    <SueldosItem key={index} onClick={() => addMenuItemView("sueldos")} />
                                ) : null;
                            default:
                                return null;
                        }
                    })}
                </List>
            </DrawerStyled>

            <Drawer open={openMenu} onClose={() => toggleDrawer()}>
                <Box sx={{ width: 250 }} role="presentation">
                    <DrawerHeader>
                    </DrawerHeader>
                    <Divider />
                    <PersonalInfo
                        triggerChangeVisibilityMenu={changeVisibilityMenu}
                        visibilityMenu={matches ? openM : openMenu}
                    />
                    <List>
                        <Divider />
                        <HomeItem onClick={() => { addMenuItemView("home"); toggleDrawer() }} />
                        {orderMenu().map((modulo, index) => {
                            switch (modulo[0]) {
                                case "buscador_interno":
                                    return <BuscadorInternosItem key={index} onClick={() => { addMenuItemView("buscador_iterno"); toggleDrawer() }} />;
                                // case "wifi":
                                //     return <WifiItem key={index} openMenu={openM} addMenuItemView={addMenuItemView} />;
                                case "alias":
                                    return hasRole(ACCESO_ALIAS) ? <AliasItem key={index} onClick={() => { addMenuItemView("alias"); toggleDrawer() }} /> : null;
                                case "difusiones":
                                    return hasRole(ACCESO_DIFUSIONES) ? <DifusionesItem key={index} onClick={() => { addMenuItemView("difusiones"); toggleDrawer() }} /> : null;
                                case "areas":
                                    return (hasRole(ACCESO_USUARIOS) || hasRole(ACCESO_ALTA_USUARIOS) || hasRole(ACCESO_AREAS) || hasRole(ACCESO_AGENDA) || hasRole(ACCESO_VER_ROLES))
                                        ? <AreasItem key={index} openMenu={openM} addMenuItemView={addMenuItemView} />
                                        : null;
                                case "noticias":
                                    return <NoticeItem key={index} onClick={() => { addMenuItemView("noticias"); toggleDrawer() }} />;
                                case "vpn":
                                    return hasRole(ACCESO_VPN) ? <VPNItem key={index} onClick={() => { addMenuItemView("vpn"); toggleDrawer() }} /> : null;
                                case "recibos":
                                    return (hasRole(ACCESO_RECIBOS) && user.legajoPersonaUTN && user.legajoPersonaUTN !== '-')
                                        ? <ReciboItem key={index} onClick={() => { addMenuItemView("recibos"); toggleDrawer() }} />
                                        : null;
                                case "traducciones":
                                    return <TraduccionesItem key={index} addMenuItemView={addMenuItemView} />;
                                case "ticketera":
                                    return (esFiliacion("Alumno") && !masDeUnaFiliacion())
                                        ? null
                                        : <TicketeraItem key={index} onClick={() => { addMenuItemView("ticketera"); toggleDrawer() }} />;
                                case "credencial":
                                    return hasRole(ACCESO_CREDENCIAL) ? <CredencialItem key={index} onClick={() => { addMenuItemView("credencial"); toggleDrawer() }} /> : null;
                                case "archivos":
                                    return <ArchivosItem key={index} onClick={() => { addMenuItemView("archivos"); toggleDrawer() }} />;
                                case "sueldos":
                                    return hasRole(ACCESO_SUELDOS) ? <SueldosItem key={index} onClick={() => { addMenuItemView("sueldos"); toggleDrawer() }} /> : null;
                                default:
                                    return null;
                            }
                        })}
                    </List>
                </Box>
            </Drawer>
        </Box>
    );
}